import HomeScreenTable from "./HomeScreenTable";

export default function HomeTable() {
  return <HomeScreenTable />;
}
